import type { FC } from 'react';
import { Spacer } from '@zillow/constellation';
import { TextButton } from '@zillow/constellation-10';

import { StyledTourCardSelectableControls } from './StyledComponents';

interface TourCardSelectableControlsProps {
  isSelected: boolean;
  onView: () => void;
  onSelect: () => void;
}

const TourCardSelectableControls: FC<TourCardSelectableControlsProps> = ({ isSelected, onView, onSelect }) => (
  <StyledTourCardSelectableControls>
    <Spacer marginRight="sm">
      <TextButton onClick={onView}>View</TextButton>
    </Spacer>
    <Spacer marginRight="sm">
      <TextButton onClick={onSelect}>{isSelected ? 'Deselect' : 'Select'}</TextButton>
    </Spacer>
  </StyledTourCardSelectableControls>
);

export type { TourCardSelectableControlsProps };
export default TourCardSelectableControls;
